module.exports = __webpack_public_path__ + "img/icon-package-3g-light.ab7d2e9.svg";